import { render, staticRenderFns } from "./BookShift.vue?vue&type=template&id=675e53ae&scoped=true"
import script from "./BookShift.vue?vue&type=script&lang=js"
export * from "./BookShift.vue?vue&type=script&lang=js"
import style0 from "./BookShift.vue?vue&type=style&index=0&id=675e53ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675e53ae",
  null
  
)

export default component.exports